module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("进展详情")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "bd"
  }, [_c('div', {
    staticClass: "group_2"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "firstStage",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.stage.stageName) + "：")]), _vm._v(" "), _c('span', {
    staticClass: "preExperiment",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.project.projectName))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project.status === '结束' || _vm.project.status === '终止'),
      expression: "project.status==='结束'||project.status==='终止'"
    }],
    staticClass: "colorDiv_2 color_greeen"
  }, [_vm._v("已完成")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project.status === '未开始'),
      expression: "project.status==='未开始'"
    }],
    staticClass: "colorDiv_2 color_red"
  }, [_vm._v("未开始")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project.status === '进行中'),
      expression: "project.status==='进行中'"
    }],
    staticClass: "colorDiv_2 color_orange"
  }, [_vm._v("进行中")])]), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('task-progress', {
    attrs: {
      "type": _vm.type,
      "subType": _vm.subType,
      "taskModules": _vm.project.taskProgresses,
      "expressOutList": _vm.expressOutList
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62f5de36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchGroupProgress/ServiceTaskProgress.vue
// module id = 1660
// module chunks = 8